import { render, staticRenderFns } from "./BoughtItems.vue?vue&type=template&id=57fb6624&"
import script from "./BoughtItems.vue?vue&type=script&lang=ts&"
export * from "./BoughtItems.vue?vue&type=script&lang=ts&"
import style0 from "./BoughtItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports